import { CardMedia, DrawerBody, NotificationBadge, SkeletonLine, TextField, Typography, } from '@one-thd/sui-atomic-components';
import { Search as SearchIcon } from '@one-thd/sui-icons';
import React, { Fragment, useEffect, useMemo, useState, } from 'react';
import { SubmitChangeStorePickupLocation } from '../../../api/oms/edit-pickup-location';
import { searchFieldPlaceholder } from '../../../constants/editPickupLocation';
import '../../../styles/drawer.scss';
import { getCookieValue } from '../../../utils/cookie-helper';
import { AlertBanner } from '../../shared/alert-banner/AlertBanner';
import { EditPickupLocationStoreCard } from './EditPickupLocationStoreCard';
import { getLineItemIds } from './utils';
import { FLOW_TYPES } from '../../../constants/out-of-stock';
import { getFlowTypeValue } from '../util/OutOfStock';
import { useOrderContext, useFulfillmentGroupContext, useEditPickupLocationContext, } from '../../../hooks/useContexts';
import { getLineItemQuantity } from '../util/general';
import { getQuantityByStatus } from '../../../utils/order-details/LineItemUtils';
import { convertedFulfillmentTypes } from '../OrderTrackingDetails';
import { CustomImage } from '../../shared/CustomImage';
import { generateImageUrl } from '../../../utils/general';
export var EditPickupLocationStoreSelection = function (_a) {
    var _b;
    var closeDrawer = _a.closeDrawer, getStoreLocations = _a.getStoreLocations, alertState = _a.alertState;
    var setShowDrawerError = useOrderContext().setShowDrawerError;
    var _c = useFulfillmentGroupContext(), fulfillmentGroup = _c.fulfillmentGroup, fulfillmentGroupIndex = _c.fulfillmentGroupIndex, fulfillmentType = _c.fulfillmentType;
    var _d = useOrderContext(), orderDetailsData = _d.orderDetailsData, orderId = _d.orderId, currentBopisOosDrawer = _d.currentBopisOosDrawer;
    var _e = useEditPickupLocationContext(), storeLocationData = _e.storeLocationData, setSelectedStoreData = _e.setSelectedStoreData, skeletonLoading = _e.skeletonLoading;
    var _f = useState(), currentStore = _f[0], setCurrentStore = _f[1];
    var _g = useState(''), searchFieldValue = _g[0], setSearchFieldValue = _g[1];
    var _h = useState(''), searchStatus = _h[0], setSearchStatus = _h[1];
    var _j = useState(''), searchStatusMessage = _j[0], setSearchStatusMessage = _j[1];
    var searchRegex = /^\d{4,5}$/;
    var lineItems = (fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.lineItems) || [];
    var itemsTotal = lineItems.reduce(function (acc, item) { return acc + getQuantityByStatus(item); }, 0);
    useEffect(function () {
        var _a, _b, _c, _d;
        if (storeLocationData &&
            ((_b = (_a = storeLocationData === null || storeLocationData === void 0 ? void 0 : storeLocationData.data) === null || _a === void 0 ? void 0 : _a.storeFulfillment) === null || _b === void 0 ? void 0 : _b.currentStore)) {
            setCurrentStore((_d = (_c = storeLocationData === null || storeLocationData === void 0 ? void 0 : storeLocationData.data) === null || _c === void 0 ? void 0 : _c.storeFulfillment) === null || _d === void 0 ? void 0 : _d.currentStore);
        }
    }, [storeLocationData]);
    var storeSelected = function (setIsLoading, store) {
        var _a, _b, _c;
        var requestData = {
            orderId: orderId,
            oldStoreNumber: (_b = (_a = fulfillmentGroup === null || fulfillmentGroup === void 0 ? void 0 : fulfillmentGroup.storePickup) === null || _a === void 0 ? void 0 : _a.store) === null || _b === void 0 ? void 0 : _b.number,
            newStoreNumber: store === null || store === void 0 ? void 0 : store.storeNumber,
            lineItems: getLineItemIds(lineItems),
            emailId: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.emailId,
            fulfillmentType: ((_c = convertedFulfillmentTypes(fulfillmentType)) === null || _c === void 0 ? void 0 : _c.toUpperCase()) || undefined,
            flowType: getFlowTypeValue(currentBopisOosDrawer, FLOW_TYPES.EDIT_PICKUP_LOCATION),
            forterToken: getCookieValue('forterToken') || undefined,
            net: orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.net,
        };
        var traceId = orderDetailsData === null || orderDetailsData === void 0 ? void 0 : orderDetailsData.traceId;
        SubmitChangeStorePickupLocation(requestData, traceId)
            .then(function (res) {
            setSelectedStoreData({ storeInfo: res.data.data, storeData: store });
        })
            .catch(function () {
            setShowDrawerError(fulfillmentGroupIndex);
            closeDrawer();
        })
            .finally(function () {
            setIsLoading(false);
        });
    };
    var handleStoreButtonClick = function (setIsLoading, store) {
        setIsLoading(true);
        storeSelected(setIsLoading, store);
    };
    var currentStoreCard = function () {
        return currentStore && (React.createElement(EditPickupLocationStoreCard, { store: currentStore, currentStore: true, handleStoreButtonClick: handleStoreButtonClick }));
    };
    // Bopis only
    var selectAStoreBopisCard = function () {
        var _a, _b;
        return storeLocationData &&
            ((_b = (_a = storeLocationData === null || storeLocationData === void 0 ? void 0 : storeLocationData.data) === null || _a === void 0 ? void 0 : _a.storeFulfillment) === null || _b === void 0 ? void 0 : _b.stores.map(function (store) { return (React.createElement(EditPickupLocationStoreCard, { store: store, currentStore: false, handleStoreButtonClick: handleStoreButtonClick })); }));
    };
    var searchError = function () {
        setSearchStatus('error');
        setSearchStatusMessage('Enter a 5 digit Zip Code or 4 digit Store number');
    };
    var handleKeyDown = function (event) {
        if (event.key === 'Enter') {
            if (searchFieldValue.match(searchRegex)) {
                getStoreLocations(searchFieldValue);
            }
            else
                searchError();
        }
    };
    var handleSearchPress = function () {
        if (searchFieldValue.match(searchRegex)) {
            getStoreLocations(searchFieldValue);
        }
        else
            searchError();
    };
    var ItemImage = function (item) {
        return useMemo(function () { return function () {
            var _a;
            return (React.createElement(CustomImage, { src: (_a = generateImageUrl(item)) !== null && _a !== void 0 ? _a : '', alt: item === null || item === void 0 ? void 0 : item.description, lazy: true, width: "48", height: "48" }));
        }; }, [item]);
    };
    return (React.createElement(DrawerBody, { overflow: "scroll" },
        React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
            React.createElement("div", null,
                React.createElement("div", null,
                    React.createElement(Typography, null,
                        React.createElement("div", { className: "sui-mb-4" },
                            itemsTotal,
                            " items for Store Pickup")),
                    React.createElement("div", { className: "sui-flex sui-gap-5" }, (_b = fulfillmentGroup.lineItems) === null || _b === void 0 ? void 0 : _b.map(function (bopisItem, index) {
                        return (React.createElement(NotificationBadge, { key: index, variant: "strong", size: "small", color: "primary", badgeContent: getLineItemQuantity(bopisItem) },
                            React.createElement(CardMedia, { component: ItemImage(bopisItem) })));
                    })))),
            React.createElement(Typography, null,
                React.createElement("div", { className: "sui--mb-3" }, "Change Location")),
            React.createElement(TextField, { placeholder: searchFieldPlaceholder, onKeyDown: handleKeyDown, onChange: function (event) {
                    if (event.target.value.match(searchRegex)) {
                        setSearchFieldValue(event.target.value);
                        setSearchStatus('');
                        setSearchStatusMessage('');
                    }
                    else
                        setSearchFieldValue('');
                }, status: searchStatus, statusMessage: searchStatusMessage, InputProps: {
                    endAdornment: (React.createElement(SearchIcon, { "data-testid": "SearchIcon", color: "medium", size: "small", onClick: handleSearchPress, cursor: "pointer" })),
                } }),
            alertState && (alertState === null || alertState === void 0 ? void 0 : alertState.status) && (React.createElement(AlertBanner, { status: alertState === null || alertState === void 0 ? void 0 : alertState.status }, alertState === null || alertState === void 0 ? void 0 : alertState.alertMessage)),
            skeletonLoading ? (Array.from({ length: 4 }, function (unused, i) { return (React.createElement(Fragment, { key: i },
                React.createElement("div", { className: "sui-flex sui-flex-row sui-my-5 sui-items-start sui-gap-3" },
                    React.createElement("div", { className: "sui-flex-1" },
                        React.createElement(SkeletonLine, { numberOfLines: 3 }))))); })) : (React.createElement(React.Fragment, null,
                currentStoreCard(),
                selectAStoreBopisCard())))));
};
// WIll be used after MVP release, when mixed carts are available
// const storeToggle = () => {
//   return (
//     <div className="sui-flex">
//       <Toggle />
//       <div className="sui-ml-2">
//         <Typography>
//           <div className="sui-text-base">Show In Stock At Nearby Stores</div>
//         </Typography>
//       </div>
//     </div>
//   );
// };
// Boss + Bopis, code will be used in near future when mixed carts are available
// const selectAStoreMixCard = (imageUrl: string) => (
//   <Card grow>
//     <div className="sui-flex sui-justify-between sui--mb-3">
//       <CardTitle
//         header={
//           <Typography weight="bold" variant="h4" height="tight">
//             Midtown Manhattan #6140
//           </Typography>
//         }
//       />
//       <Typography weight="bold" style={{ alignContent: 'center' }}>
//         2.4 mi
//       </Typography>
//     </div>
//     <CardBody>
//       <Typography>
//         <div className="sui-mb-4">
//           <div>410 East 61st Street</div>
//           <div>New York, NY 10065</div>
//         </div>
//       </Typography>
//       {mixedCartAccordian(imageUrl)}
//       <EditPickupLocationStoreHoursAccordion />
//     </CardBody>
//     <Button
//       style={{ width: '100%', marginTop: '-16px' }}
//       grow
//       fullWidth
//       variant="secondary"
//       onClick={() => {
//         storeSelected();
//       }}
//     >
//       Select This Store
//     </Button>
//   </Card>
// );
// Used to control tab view, will remove once we have a final decision on whether we will have a tab view or not
// const handleChange = (event: ChangeEvent, newValue: string) => {
//   setValue(newValue);
// };
// Not 100% sure yet if we will have a tab view or not, discussions underway with the team. Will update this section once we have a final decision
// const [value, setValue] = useState('1');
// const tabView = (
//   value: string,
//   handleChange: (event: ChangeEvent, value: string) => void,
// ) => (
//   <div className="sui-col-span-12">
//     <TabController value={value}>
//       <TabList
//         variant="fullWidth"
//         centered
//         onChange={handleChange}
//         aria-label="tabs context example"
//       >
//         <Tab label="List View" value="1" />
//         <Tab label="Map View" value="2" />
//       </TabList>
//       {/* <TabPanel value="1">{getStoreView(false)}</TabPanel> */}
//       <TabPanel value="2">
//         {/* <Map
//           showMap
//           stores={stores?.filter(
//             (store) => inStockTodayFilter({
//               inStockFilter, store, quantity
//             })
//           )}
//           storeId={storeId}
//           useMccData={useMccData}
//           setSearchBarDynInput={setSearchBarDynInput}
//         /> */}
//         <div className="sui-pt-2">
//           <Typography variant="body-lg" height="tight">
//             Select the pin on the map to see store information
//           </Typography>
//         </div>
//         {/* {getStoreView(true)} */}
//       </TabPanel>
//     </TabController>
//   </div>
// );
